import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMachinesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 145,
	height: 145,
	viewBox: "0 0 145 145",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M72.395 143.435C111.629 143.435 143.435 111.629 143.435 72.395C143.435 33.1607 111.629 1.35498 72.395 1.35498C33.1607 1.35498 1.35498 33.1607 1.35498 72.395C1.35498 111.629 33.1607 143.435 72.395 143.435Z",
			stroke: "white",
			strokeWidth: 2.71,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.045 48.725V99.465C114.045 109.615 106.285 117.845 96.7047 117.845H49.9147C40.3347 117.845 32.5747 109.615 32.5747 99.465V48.725",
			stroke: "#E44EA8",
			strokeWidth: 5.62,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M96.7047 30.345C106.145 32.075 114.045 38.575 114.045 48.725V99.465C114.045 109.615 106.285 117.845 96.7047 117.845H49.9147C40.3347 117.845 32.5747 109.615 32.5747 99.465V48.725C32.5747 38.575 40.3347 30.345 49.9147 30.345C49.9147 30.345 74.6047 26.285 96.7047 30.345Z",
			stroke: "white",
			strokeWidth: 5.62,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.6348 49.945H111.775",
			stroke: "white",
			strokeWidth: 5.62,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.3148 105.165C85.1392 105.165 94.7248 95.5794 94.7248 83.755C94.7248 71.9306 85.1392 62.345 73.3148 62.345C61.4904 62.345 51.9048 71.9306 51.9048 83.755C51.9048 95.5794 61.4904 105.165 73.3148 105.165Z",
			stroke: "white",
			strokeWidth: 5.62,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.2046 85.665C57.9146 82.645 63.2046 80.855 68.6946 83.205C70.7146 84.065 72.3946 85.525 74.1846 86.805C76.8746 88.725 79.8946 90.285 83.1546 90.835C87.6546 91.595 91.3946 91.195 94.0346 87.375",
			stroke: "white",
			strokeWidth: 5.62,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.8448 43.845C48.4906 43.845 49.8248 42.5108 49.8248 40.865C49.8248 39.2192 48.4906 37.885 46.8448 37.885C45.1989 37.885 43.8647 39.2192 43.8647 40.865C43.8647 42.5108 45.1989 43.845 46.8448 43.845Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.8848 44.095C56.5306 44.095 57.8648 42.7608 57.8648 41.115C57.8648 39.4692 56.5306 38.135 54.8848 38.135C53.239 38.135 51.9048 39.4692 51.9048 41.115C51.9048 42.7608 53.239 44.095 54.8848 44.095Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.9248 44.345C64.5706 44.345 65.9048 43.0108 65.9048 41.365C65.9048 39.7192 64.5706 38.385 62.9248 38.385C61.279 38.385 59.9448 39.7192 59.9448 41.365C59.9448 43.0108 61.279 44.345 62.9248 44.345Z",
			fill: "white"
		})
	]
});
export default SvgMachinesIcon;
